import axios from "api/axios"
import {
  APIResponse,
  Config,
  NoContentType,
  PaginatedAPIResponse,
} from "api/types"
import {
  formatErrorResponse,
  formatSuccessResponse,
  logAPIError,
} from "api/utils"

import {
  ChangePlanResponse,
  IntentResponseForStripe,
  Subscription,
} from "./types"
import { urls } from "./urls"

export default {
  list: async ({
    params,
  }: Config): Promise<PaginatedAPIResponse<Subscription[]>> => {
    try {
      const res = await axios.get(urls.list(), { params })
      return formatSuccessResponse(res, { paginatedResponse: true })
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },

  createSetupIntent: async (): Promise<
    APIResponse<IntentResponseForStripe>
  > => {
    try {
      const res = await axios.post(urls.createSetupIntent())
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },

  updatePaymentMethod: async ({
    data,
  }: Config): Promise<APIResponse<NoContentType>> => {
    try {
      const res = await axios.put(urls.updatePaymentMethod(), data)
      return formatSuccessResponse(res)
    } catch (e) {
      const error = formatErrorResponse(e)
      logAPIError(error)
      throw error
    }
  },

  changePlan: async ({
    data,
  }: Config): Promise<APIResponse<ChangePlanResponse | NoContentType>> => {
    try {
      const res = await axios.post(urls.changePlan(), data)
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
}
